import { FormProvider } from 'react-hook-form';
import { SetupCampaignConfigurations } from './components/SetupCampaignConfigurations/SetupCampaignConfigurations';
import { SetupCampaignFooter } from './components/SetupCampaignFooter/SetupCampaignFooter';
import { SetupCampaignType } from './components/SetupCampaignType/SetupCampaignType';
import { SetupCampaignCallout } from './components/SetupCampanhasCallout/SetupCampaignCallout';
import { useCampaign } from './hooks/useCampaign';
import styles from './main.module.scss';

export const SetupCampaign = () => {
  const { handlers, form } = useCampaign();
  return (
    <form onSubmit={form.handleSubmit(handlers.handleSubmitConfig)} className={styles.main}>
      <FormProvider {...form}>
        <SetupCampaignType />
        <SetupCampaignConfigurations />
        <SetupCampaignCallout />
        <SetupCampaignFooter />
      </FormProvider>
    </form>
  );
};
